<template>
    <p class="p4">
        <slot />
    </p>
</template>
